import { render, staticRenderFns } from "./PromoBoxSection.vue?vue&type=template&id=47dad057"
import script from "./PromoBoxSection.vue?vue&type=script&lang=js"
export * from "./PromoBoxSection.vue?vue&type=script&lang=js"
import style0 from "../../../assets/partner-scss/partners/shoper/sections/_promobox.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports